import { createActions } from "reduxsauce";

export const { Types, Creators } = createActions({
  clearOfferFilterPhrase: ["data"],
  addSuggestedStore: ["data"],
  clearSelectedSuggestionData: null,
  storeSelectedSuggestionData: ["data"],
  checkEmailAvailability: ["email"],
  checkEmailAvailabilitySuccess: ["data"],
  checkEmailAvailabilityFailure: ["error"],
  checkRegistrationCode: ["code"],
  checkRegistrationCodeSuccess: ["data"],
  checkRegistrationCodeFailure: ["error"],
  checkMemberId: ["memberId"],
  checkMemberIdSuccess: ["data"],
  checkMemberIdFailure: ["error"],
  completeAccountSetup: ["memberData"],
  completeAccountSetupSuccess: ["data"],
  completeAccountSetupFailure: ["error"],
  resetAuth: null,
  setSignUpStep: ["payload"],
  setDirectedParams: ["payload"],
  fetchingProgram: ["url"],
  fetchingProgramSuccess: ["program"],
  fetchingProgramFailure: ["error"],
  setSessionExpired: null,
  createMember: ["memberData"],
  createMemberSuccess: ["data"],
  createMemberFailure: null,
  setAuthOpen: ["open", "screen"],
  setAuthScreen: ["payload"],
  signIn: ["credentials"],
  authByCvt: ["credentials"],
  authBySsoToken: ["data"],
  completeMemberProfile: ["memberData"],
  completeMemberSuccess: ["data"],
  completeMemberFailure: ["error"],
  signInSuccess: ["memberData"],
  signInFailure: null,
  signOut: ["route"],
  signOutSuccess: null,
  signOutFailure: null,
  validateSession: null,
  validateSessionSuccess: ["memberData"],
  validateSessionFailure: ["error"],
  fetchingCategories: ["payload"],
  fetchingCategoriesSuccess: ["data"],
  fetchingCategoriesFailure: null,
  viewMoreReset: null,
  selectKeyword: ["keyword"],
  selectPhrase: ["phrase"],
  selectCategoryPhrase: ["phrase"],
  setTempPhrase: ["phrase"],
  handleLocationTermChange: ["value"],
  selectLocation: ["location"],
  selectCategoryTemp: ["id"],
  selectCategory: ["id"],
  setCustomSubCategories: ["subCategories"],
  selectSubCategory: ["id"],
  selectFutureSubCategory: ["id"],
  fetchingCurrentLocation: null,
  fetchingCurrentLocationSuccess: ["payload"],
  fetchingCurrentLocationFailure: ["payload"],
  resetGeoError: null,
  changeResultsPage: ["page"],
  filterChangingHowToRedeem: ["redeemMethod"],
  filterChangingDistance: ["distance"],
  filterChangingOnline: ["online"],
  filterChangingHowToSort: ["sortKey"],
  filterChangingDealsNav: ["payload"],
  fetchingUserlocation: null,
  fetchingUserlocationSuccess: ["data"],
  fetchingUserlocationFailure: null,
  fetchMemberAccount: null,
  fetchMemberAccountSuccess: ["data"],
  fetchMemberAccountFailure: null,
  updateMemberAccount: ["data"],
  updateMemberAccountSuccess: ["data"],
  updateMemberAccountFailure: null,
  getDefaultLocation: null,
  // rehydrate: ["payload"],
  // locationChange: ["location"],
  filterResetCategory: ["id"],
  filterCategoryChange: ["id"],
  fetchDeals: ["params"],
  fetchDealsSuccess: ["response"],
  fetchDealsFailure: ["response"],
  fetchSearchResults: ["params"],
  fetchSearchResultsSuccess: ["response"],
  fetchSearchResultsFailure: ["response"],
  fetchMapSearchResults: ["params"],
  fetchMapSearchResultsSuccess: ["response"],
  fetchMapSearchResultsFailure: ["response"],
  fetchGeoLocationResults: ["params"],
  fetchGeoLocationResultsSuccess: ["response"],
  fetchGeoLocationResultsFailure: ["response"],
  resetGeoLocationResults: null,
  fetchGeoLocationDetails: ["params", "target"],
  fetchGeoLocationDetailsSuccess: ["response"],
  fetchGeoLocationDetailsFailure: ["response"],
  fetchRecentLocations: ["params"],
  fetchRecentLocationsSuccess: ["response"],
  fetchRecentLocationsFailure: ["response"],
  fetchSearchSuggestions: ["term"],
  fetchSearchSuggestionsSuccess: ["response"],
  fetchSearchSuggestionsFailure: ["response"],
  clearSearchSuggestions: null,
  setCurrentLocation: ["locationObj"],
  setRecentLocation: ["locationObj"],
  setRecentLocationSuccess: ["response"],
  setRecentLocationFailure: ["response"],
  resetCategory: null,
  resetSubCategory: null,
  fetchStoreLocation: ["params"],
  fetchStoreLocationSuccess: ["response"],
  fetchStoreLocationFailure: ["response"],
  fetchStoreData: ["params"],
  fetchStoreDataSuccess: ["response"],
  fetchStoreDataFailure: ["response"],
  fetchOfferKey: ["params"],
  fetchOfferKeySuccess: ["response"],
  fetchOfferKeyFailure: ["response"],
  resetStoreLocation: null,
  closeUseLocationMsg: null,
  getPreferences: null,
  getPreferencesSuccess: ["response"],
  getPreferencesFailure: ["response"],
  setPreferences: ["params"],
  setPreferencesSuccess: ["response"],
  setPreferencesFailure: ["response"],
  addTravelStartTab: ["payload"],
  resetTravelStartTab: null,
  adminAddMembers: ["members", "program_key"],
  adminAddMembersSuccess: ["response"],
  adminAddMembersFailure: ["response"],
  clearAddMembersStatus: null,
  adminEditMember: ["program_key", "member"],
  adminEditMemberSuccess: ["response"],
  adminEditMemberFailure: ["response"],
  clearEditMemberStatus: null,
  adminGetMembers: ["program_key", "page", "searchValue", "mergeResponse"],
  adminGetMembersSuccess: ["payload"],
  adminGetMembersFailure: ["response"],
  adminGetMember: ["program_key", "member_key"],
  adminClearMembers: null,
  adminGetMemberSuccess: ["response"],
  adminGetMemberFailure: ["response"],
  adminGetActiveMemberCount: null,
  adminGetActiveMemberCountSuccess: ["payload"],
  adminGetActiveMemberCountFailure: null,
  clearGetMemberStatus: null,
  adminToolUnauthorized: ["response"],
  fetchRecommendations: null,
  fetchRecommendationsSuccess: ["payload"],
  fetchRecommendationsFailure: ["payload"],
  fetchBannerDeals: ["params"],
  fetchBannerDealsSuccess: ["payload"],
  fetchBannerDealsFailure: ["error"],
  fetchHotDeals: null,
  fetchHotDealsSuccess: ["payload"],
  fetchHotDealsFailure: ["error"],
  fetchOurPicks: null,
  fetchOurPicksSuccess: ["payload"],
  fetchOurPicksFailure: ["error"],
  fetchFeaturedDeals: ["params"],
  fetchFeaturedDealsSuccess: ["payload"],
  fetchFeaturedDealsFailure: ["error"],
  fetchFavoritesNearby: ["location"],
  fetchFavoritesNearbySuccess: ["payload"],
  fetchFavoritesNearbyFailure: ["error"],
  fetchTopOnlineDeals: ["params"],
  fetchTopOnlineDealsSuccess: ["payload"],
  fetchTopOnlineDealsFailure: ["error"],
  fetchPopularBrands: ["location"],
  fetchPopularBrandsSuccess: ["payload"],
  fetchPopularBrandsFailure: ["error"],
  fetchIp: null,
  fetchIpSuccess: ["payload"],
  fetchIpFailure: ["error"],
  getNearbyLocationsOffers: ["payload"],
  getNearbyLocationsOffersSuccess: ["payload"],
  getNearbyLocationsOffersFailure: ["error"],
  setNearbyLocationsDistance: ["payload"],
  fetchRecentSearches: null,
  fetchRecentSearchesSuccess: ["payload"],
  fetchRecentSearchesFailure: ["error"],
  updateLanguage: ["language"],
  languageSelection: ["open"],
  fetchMemberDefaultLocation: null,
  fetchMemberDefaultLocationSuccess: ["data"],
  fetchMemberDefaultLocationFailure: null,
  // setStoreMappings: ["payload"],
  // setAttractionsList: ["payload"],
  showSetupLaterNotification: ["setupLater"],
  setCurrentNav: ["payload"],
  resetCurrentNav: null,
});
